export default __webpack_public_path__ + "images/56e4ae4c6eb7871d746e45a3733ee1b4-copy.svg";